import { jsx } from "react/jsx-runtime";
import { ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { XThin } from "@nxt-costco-com/forge-icons/icons/XThin";
import { COMPONENT_NAME } from "./constants.js";
import { StyledCloseIconButton } from "./styles.js";
import { getDataTestId } from "../../../Util/index.js";
const ModalCloseButton = ({
  ariaLabel = "close",
  onClose,
  uniqueId
}) => {
  return /* @__PURE__ */ jsx(
    StyledCloseIconButton,
    {
      "aria-label": ariaLabel,
      onClick: onClose,
      disableRipple: true,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      children: /* @__PURE__ */ jsx(XThin, { color: ColorGray900, width: "20px", height: "20px" })
    }
  );
};
ModalCloseButton.displayName = COMPONENT_NAME;
export {
  ModalCloseButton
};
